<div class="container">
  <form [formGroup]="detailForm" (ngSubmit)="onSave()">
    <input hidden formControlName="userId">

    <div class="row">

      <div class="col-4">
        <mat-form-field class="w-100">
          <mat-label>{{ 'PROFILE' | translate }}</mat-label>
          <input matInput formControlName="userName">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-9">
        <mat-form-field class="w-100">
          <mat-label>{{ 'FIRSTNAME' | translate }}</mat-label>
          <input matInput formControlName="firstName">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-9">
        <mat-form-field class="w-100">
          <mat-label>{{ 'LASTNAME' | translate }}</mat-label>
          <input matInput formControlName="lastName">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-9">
        <mat-form-field class="w-100">
          <mat-label>{{ 'EMAIL.EMAIL' | translate }}</mat-label>
          <input matInput formControlName="email">
        </mat-form-field>
      </div>

    </div>

    <div class="row">

      <div class="col-9">
        <mat-checkbox formControlName="enabled" color='primary'>
          {{ 'ENABLED' | translate }}
        </mat-checkbox>
      </div>

    </div>

    <div class="row">

      <div class="col-9">
        <mat-form-field class="w-100">
          <mat-label>{{ 'PASSWORD' | translate }}</mat-label>
          <input matInput formControlName="password">
        </mat-form-field>
      </div>

    </div>

    <div class="row">
      <div class="col-4">
        <button type="submit" mat-raised-button color="primary" [disabled]="!detailForm.valid" class="me-2">
          {{ 'SAVE.SAVE' | translate }}
        </button>
        <button type="button" mat-raised-button (click)="onCancel()">
          {{ 'CANCEL' | translate }}
        </button>
      </div>
    </div>

  </form>

</div>
